import _ from 'lodash';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {FmlxButton, FmlxComboBox, FmlxDropdown, FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';
import {useManageAssignmentContext} from '../../../lib/contexLib';
import {FMLX_BUTTON, FMLX_COMPONENT} from '../../../const/FmlxComponentEnum';
import {ALERT_VARIANT, RESPONSE_STATUS, REVIEW_TYPE, EReviewStatus} from '../../../const/dataEnum';
import {setAlert} from '../../../stores/actions/alertModalStateAction';
import manageAssignmentBusiness from '../../../stores/business/manageAssignmentBusiness';
import projectBusiness from '../../../stores/business/projectBusiness';
import './AssignmentTab.scss';
import employeeReviewApi from '../../../api/rest/employeeReviewApi';
import EssSimpleTable from '../../../components/MessageTable/TableColumn/EssSimpleTable';
import employeeApi from '../../../api/rest/employeeApi';

const tabIndex = 0;
const AssignmentTab = () => {
  const dispatch = useDispatch();
  const {
    selectedTab,
    periodId,
    departmentId,
    practiceId,
    projectId,
    employeeName,
    period,
    editReviewList,
    setEditReviewList,
    selectedRowItemIdRef,
  } = useManageAssignmentContext();
  const [dataState, setDataState] = useState([]);
  const [responseStatus, setResponseStatus] = useState(RESPONSE_STATUS.IDLE);
  const [totalItem, setTotalItem] = useState();
  const [pageIndexState, setPageIndexState] = useState(0);
  const [pageSizeState, setPageSizeState] = useState(10);
  const [pageNoState, setPageNoState] = useState(0);
  const [employeeList, setEmployeeList] = useState([]);

  const [sortState, setSortState] = useState({
    sortBy: 'fullName',
    sortType: 'asc',
  });
  const [loading, setLoading] = useState(false);
  const reviewTypeItem = Object.entries(REVIEW_TYPE).map(([key, val], i) => {
    return {
      id: i,
      text: val.Name,
      group: val,
    };
  });
  const pageSizes = [10, 20, 30, 40, 50];
  const shouldCallApiRef = useRef(true);

  const onProjectChangeHandler = (revieweeId, selectedReviewerIndex, projectID) => {
    setEditReviewList((reviewList) => {
      const newReviewList = [...reviewList];
      const selectedRevieweeIndex = newReviewList[selectedReviewerIndex].data.findIndex(
        (item) => item.id === revieweeId
      );
      newReviewList[selectedReviewerIndex].data[selectedRevieweeIndex].projectID = projectID;
      return newReviewList;
    });
  };

  const onEditRevieweeClickHandler = async (reviewerId, employee, reviewees) => {
    selectedRowItemIdRef.current = reviewerId;
    let newReviewees = [...reviewees];
    if (shouldCallApiRef.current) {
      setLoading(true);
      newReviewees = await manageAssignmentBusiness.getOngoingRevieweeWithProject(newReviewees);
      shouldCallApiRef.current = false;
      setLoading(false);
      setEditReviewList([
        {
          id: reviewerId,
          employee,
          data: newReviewees,
        },
      ]);
      shouldCallApiRef.current = false;
    }
  };

  const columns = [
    {
      Header: 'Reviewer Name',
      accessor: 'fullName',
      editable: false,
      headerStyle: {
        width: '30%',
        minWidth: '30%',
        maxWidth: '30%',
      },
    },
    {
      Header: 'Reviewee Name',
      accessor: 'reviewees',
      editable: false,
      disableSort: true,
      hideSort: true,
      hideFilter: true,
      headerStyle: {
        width: '40%',
        minWidth: '40%',
        maxWidth: '40%',
      },
      Cell: (props) => {
        const {value} = props;
        const reviewerId = props.row.original.id;
        let selectedRevieweesDropdown = [];
        let editState = editReviewList.find((data) => data.id === props.row.original.id);
        let editStateIndex = editReviewList.findIndex((data) => data.id === props.row.original.id);
        let reviewees = editState ? editState.data : value;
        const isButtonEditDisabled = editReviewList.length > 0 && !editState;
        const isRowSelected = reviewerId === selectedRowItemIdRef.current;

        const onChangeEmployeeAddCB = async (item) => {
          if (item) {
            let editReview = [...editReviewList];

            if (editReview[editStateIndex].data.find((data) => data.id === item.id) === undefined) {
              setLoading(true);
              const employeeProjects = await manageAssignmentBusiness.getEmployeeProjectsByPeriod(item.id, periodId);
              setLoading(false);
              editReview[editStateIndex].data.push({
                id: item.data?.id,
                fullName: item.data?.fullName,
                departmentID: item.data?.departmentID,
                practiceID: item.data?.practiceID,
                reviewTypeID: item.id === editReview[editStateIndex].id ? REVIEW_TYPE.SELF.Id : REVIEW_TYPE.PEER.Id,
                reviewTypeName:
                  item.id === editReview[editStateIndex].id ? REVIEW_TYPE.SELF.Name : REVIEW_TYPE.PEER.Name,
                projectID: employeeProjects[0]?.project?.id,
                projects: employeeProjects.map((emp) => ({
                  id: emp.project.id,
                  text: emp.project.projectName,
                  group: '',
                })),
                // status: "ongoing",
              });
            } else {
              dispatch(
                setAlert({
                  show: true,
                  variant: ALERT_VARIANT.ERROR,
                  message: 'Reviewee already in the list',
                })
              );
            }
            setEditReviewList(editReview);
          }
        };
        return (
          <React.Fragment>
            <div className="assignment-tab" key={'reviewees' + props.row.original.id}>
              {reviewees?.map((reviewee, i) => {
                selectedRevieweesDropdown.push({id: reviewee.id, text: reviewee.fullName, group: '', data: reviewee});
                let allowEdit =
                  reviewee.reviewTypeName !== REVIEW_TYPE.CONS.Name &&
                  reviewee.fullName !== props.row.original.fullName;
                /** get project by reviewee's projects */
                const selectedRevieweeProject = projectBusiness.getProjectById(reviewee.projects, reviewee.projectID);
                return (
                  <div
                    className={`table-grid ${editState ? 'edit-state' : 'normal'}`}
                    key={reviewee.id + reviewee.reviewTypeID + i}
                  >
                    <div className="table-content">
                      <FmlxTooltip title={reviewee.fullName}>
                        <span>{reviewee.fullName}</span>
                      </FmlxTooltip>
                    </div>
                    <div className="table-content">
                      {editState && reviewee.status !== EReviewStatus.DONE && allowEdit ? (
                        <FmlxDropdown
                          size={FMLX_COMPONENT.SIZE.S}
                          items={reviewee.projects}
                          disabled={loading}
                          selectedItem={selectedRevieweeProject?.id}
                          onChange={(projectID) => {
                            onProjectChangeHandler(reviewee.id, editStateIndex, projectID);
                          }}
                        />
                      ) : (
                        reviewee?.projectName
                      )}
                    </div>
                    <div className="table-content">
                      {editState && reviewee.status !== EReviewStatus.DONE && allowEdit ? (
                        <FmlxDropdown
                          placeholder="Select Review Type"
                          items={reviewTypeItem.filter(
                            (RT) => RT.text !== REVIEW_TYPE.CONS.Name && RT.text !== REVIEW_TYPE.SELF.Name
                          )}
                          selectedItem={reviewTypeItem.find((RT) => RT.text === reviewee.reviewTypeName).id}
                          onChange={(item) => {
                            let editReview = [...editReviewList];
                            let editedRevieweeIndex = reviewees.findIndex((data) => data.id === reviewee.id);
                            let revieweeList = _.cloneDeep(reviewees);
                            revieweeList[editedRevieweeIndex].reviewTypeName = reviewTypeItem[item].text;
                            revieweeList[editedRevieweeIndex].reviewTypeID = reviewTypeItem[item].group.Id;
                            editReview[editStateIndex].data = _.cloneDeep(revieweeList);
                            setEditReviewList(editReview);
                          }}
                          size={FMLX_COMPONENT.SIZE.S}
                          disabled={loading}
                        />
                      ) : (
                        `(${reviewee.reviewTypeName})`
                      )}
                    </div>
                    {editState ? (
                      <div className="reviewee-delete" key={'revieweesSaveButton' + props.row.original.id + i}>
                        <FmlxButton
                          size={FMLX_COMPONENT.SIZE.M}
                          type={FMLX_BUTTON.TYPE.BASIC}
                          variant={FMLX_BUTTON.VARIANT.PLAIN}
                          disabled={reviewee.status === EReviewStatus.DONE || !allowEdit || loading}
                          label=""
                          onClick={() => {
                            let editReview = [...editReviewList];
                            let revieweeIndex = reviewees.findIndex((data) => data.id === reviewee.id);
                            let revieweeList = _.cloneDeep(reviewees);
                            revieweeList.splice(revieweeIndex, 1);
                            editReview[editStateIndex].data = _.cloneDeep(revieweeList);
                            setEditReviewList(editReview);
                          }}
                          onlyIcon={true}
                          icon={<FmlxIcon name={'Trash'} size={FMLX_COMPONENT.SIZE.M} />}
                          withTooltip={false}
                          tooltipPlacement={'top'}
                          tooltipDescription={'Delete Reviewee'}
                        ></FmlxButton>
                      </div>
                    ) : (
                      <React.Fragment></React.Fragment>
                    )}
                  </div>
                );
              })}
              <div className="reviewee-action-container" key={props.row.original.id + 'Action'}>
                {editState ? (
                  <React.Fragment>
                    <div className="reviewee-combobox-wrapper">
                      <FmlxComboBox
                        // multiple
                        placeholder="Select Reviewee"
                        disabled={loading}
                        items={employeeList}
                        // selectedMultipleItem={selectedRevieweesDropdown}
                        onChange={onChangeEmployeeAddCB}
                        // onEnterKeyPressed={onChangeEmployeeAddCB}
                      />
                    </div>
                    <FmlxButton
                      size={FMLX_COMPONENT.SIZE.M}
                      type={FMLX_BUTTON.TYPE.DANGER}
                      variant={FMLX_BUTTON.VARIANT.CONTAIN}
                      disabled={loading}
                      onClick={() => {
                        setEditReviewList([]);
                        shouldCallApiRef.current = true;
                      }}
                      onlyIcon
                      withTooltip
                      tooltipDescription="Cancel"
                      withIcon={FMLX_BUTTON.WITH_ICON.START}
                      icon={<FmlxIcon name={'CancelOutline'} size={FMLX_COMPONENT.SIZE.M} />}
                    ></FmlxButton>
                    <FmlxButton
                      showProgress={loading}
                      size={FMLX_COMPONENT.SIZE.M}
                      type={FMLX_BUTTON.TYPE.POSITIVE}
                      variant={FMLX_BUTTON.VARIANT.CONTAIN}
                      label="SAVE"
                      onClick={() => {
                        saveReviewee(props.row.original.id, reviewees, editStateIndex);
                      }}
                      // onlyIcon={true}
                      withIcon={FMLX_BUTTON.WITH_ICON.START}
                      icon={<FmlxIcon name={'Save'} size={FMLX_COMPONENT.SIZE.M} />}
                    ></FmlxButton>
                  </React.Fragment>
                ) : (
                  period?.isActive && (
                    <FmlxButton
                      showProgress={loading && isRowSelected}
                      size={FMLX_COMPONENT.SIZE.M}
                      type={FMLX_BUTTON.TYPE.PRIMARY}
                      variant={FMLX_BUTTON.VARIANT.CONTAIN}
                      disabled={loading || isButtonEditDisabled}
                      label="EDIT"
                      onClick={() => {
                        onEditRevieweeClickHandler(props.row.original.id, props.row.original, value);
                      }}
                      // onlyIcon={true}
                      withIcon={FMLX_BUTTON.WITH_ICON.START}
                      icon={<FmlxIcon name={'PencilBorder'} size={FMLX_COMPONENT.SIZE.M} />}
                    ></FmlxButton>
                  )
                )}
              </div>
            </div>
          </React.Fragment>
        );
      },
    },
    {
      Header: 'Review Status',
      accessor: '',
      editable: false,
      disableSort: true,
      hideSort: true,
      hideFilter: true,
      headerStyle: {
        width: '10%',
        minWidth: '10%',
        maxWidth: '10%',
      },
      Cell: ({value, row}) => {
        const reviewees = row.original.reviewees;
        const rowEditState = editReviewList.find((data) => data.id === row.original.id);
        return (
          <div className="height-100">
            {reviewees.map((reviewee) => {
              const key = `assignment-tab-${reviewee.id}`;
              return (
                <div key={key} className={`table-grid ${rowEditState ? 'edit-state' : 'normal'}`}>
                  <div className={`table-content ${rowEditState ? 'with-fixed-height' : ''}`}>{reviewee.status}</div>
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      Header: 'Total',
      accessor: 'totalReviewees',
      editable: false,
      headerStyle: {
        width: '20%',
        minWidth: '20%',
        maxWidth: '20%',
      },
    },
  ];

  const columnData = [
    {
      id: 'fullName',
      accessor: 'fullName',
      Header: 'Reviewer Name',
      sortable: true,
      renderCell: (col, row) => row.fullName,
    },
    {
      id: 'reviewees',
      accessor: 'reviewees',
      Header: 'Reviewee Name',
      sortable: false,
      renderCell: (col, row) => columns[1].Cell?.({value: row.reviewees, row: {original: row}}),
    },
    {
      id: 'status',
      accessor: 'status',
      Header: 'Review Status',
      sortable: false,
      renderCell: (col, row) => columns[2].Cell?.({value: null, row: {original: row}}),
    },
    {
      id: 'totalReviewees',
      accessor: 'totalReviewees',
      Header: 'Total',
      sortable: true,
      renderCell: (col, row) => row.totalReviewees,
    },
  ];

  const getTableData = useCallback(
    async ({period, employee, practice, project, department, sort, pageNo, pageSize}) => {
      if (period !== 0 && department !== null) {
        setResponseStatus(RESPONSE_STATUS.PENDING);
        try {
          const response = await employeeReviewApi.getRevieweeAssigment({
            periodId,
            employee,
            practiceId: practice,
            projectId: project,
            departmentId: department,
            sortBy: sort.sortBy,
            sortType: sort.sortType,
            pageNo,
            pageSize,
          });
          if (!response) return;
          const {data, responseCode, totalCount} = response;
          if (responseCode === 0) {
            setTotalItem(totalCount);
            setDataState(
              data.map((item) => ({
                ...item,
                reviewees: item.reviewees.map((reviewee) => ({
                  ...reviewee,
                  projects: [],
                })),
              }))
            );
          } else if (responseCode === -10) {
            setTotalItem(0);
            setDataState([]);
          }
          setResponseStatus(RESPONSE_STATUS.SUCCESS);
        } catch (error) {
          dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: error.message}));
          setResponseStatus(RESPONSE_STATUS.ERROR);
        }
      }
    },
    [dispatch, periodId]
  );

  const fetchEmployee = useCallback(async () => {
    const response = await employeeApi.getEmployee();
    try {
      const {data, responseCode} = response;
      if (responseCode === 0) {
        let emps = data.map((employee, index) => ({
          id: employee.id,
          text: employee.fullName,
          group: '',
          data: employee,
        }));
        setEmployeeList(emps);
      }
    } catch (error) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: error.message}));
    }
  }, [dispatch]);

  const fetchData = useCallback(
    ({pageSize, pageIndex}) => {
      setPageSizeState(pageSize);
      setPageIndexState(pageIndex);
      setPageNoState(pageIndex + 1);
      setEditReviewList([]);
      shouldCallApiRef.current = true;
      getTableData({
        period: periodId,
        employee: employeeName,
        practice: practiceId,
        project: projectId,
        department: departmentId,
        sort: sortState,
        pageNo: pageIndex + 1,
        pageSize,
      });
    },
    [setEditReviewList, getTableData, periodId, employeeName, practiceId, projectId, departmentId, sortState]
  );

  useEffect(() => {
    fetchEmployee();
  }, [fetchEmployee]);

  useEffect(() => {
    if (selectedTab === tabIndex) {
      fetchData({pageSize: pageSizeState, pageIndex: 0});
    }
  }, [selectedTab, fetchData]);

  const getSortValue = ({type, column}) => {
    setSortState({
      sortBy: column,
      sortType: type,
    });
  };

  const saveReviewee = async (reviewerID, data, editIndex) => {
    const dataparam = {
      id: reviewerID,
      reviewees: data.map((item) => ({
        id: item.id,
        departmentID: item.departmentID,
        fullName: item.fullName,
        practiceID: item.practiceID,
        reviewTypeID: item.reviewTypeID,
        reviewTypeName: item.reviewTypeName,
        status: item.status,
        projectID: item?.projectID,
      })),
    };
    const param = {
      reviewPeriod: periodId,
    };
    setLoading(true);
    try {
      const response = await employeeReviewApi.syncReviewee(dataparam, param);
      const {message, responseCode} = response;
      if (responseCode === 0) {
        setEditReviewList(_.cloneDeep(editReviewList).splice(editIndex + 1, 1));
        fetchData({pageSize: pageSizeState, pageIndex: pageIndexState});
        dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: message}));
      } else {
        dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: message}));
      }
    } catch (error) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: error.message}));
    } finally {
      setLoading(false);
      shouldCallApiRef.current = true;
    }
  };

  const memoizedDataSource = useMemo(() => dataState, [dataState]);

  const handleChangeRowsPerPage = (e) => {
    const newPageSize = parseInt(e.target.value, 10);
    const startIndex = pageIndexState * pageSizeState;
    const newPageIndex = Math.floor(startIndex / newPageSize);
    fetchData({pageSize: newPageSize, pageIndex: newPageIndex});
  };
  /**
   * https://kentcdodds.com/blog/stop-using-isloading-booleans
   * const isLoading = status === 'idle' || status === 'pending'
   * const isResolved = status === 'resolved'/'success'
   * const isRejected = status === 'rejected'/'error'
   */
  return (
    <EssSimpleTable
      columnData={columnData}
      columns={(col, row) => row[col.accessor]}
      dataCount={Array(totalItem).fill(0)}
      filteredData={memoizedDataSource}
      sortTableDirection={sortState.sortType}
      sortKey={sortState.sortBy}
      onSort={(column) => {
        const type = sortState.sortBy === column && sortState.sortType === 'asc' ? 'desc' : 'asc';
        getSortValue({type, column});
      }}
      onChangePage={(e, newPage) => fetchData({pageSize: pageSizeState, pageIndex: newPage})}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      onPageOption={pageSizes}
      rowsPerPage={pageSizeState}
      page={pageIndexState}
      hideFooter={false}
      hideHeader={false}
      onEmptyDataShow="No data available"
      showDisplaySettings
    />
  );
};

export default AssignmentTab;
